import {
  ADD_RETURN_REASON,
  CLEAR_CREATE_RETURN_REASON_ERROR,
  CLEAR_UPDATE_RETURN_REASON_ERROR,
  CLOSE_CREATE_RETURN_REASON_MODAL,
  CLOSE_UPDATE_RETURN_REASON_MODAL,
  CREATE_RETURN_REASON_ERROR,
  CREATE_RETURN_REASON_PENDING,
  CREATE_RETURN_REASON_SUCCESS,
  GET_RETURN_REASON_PENDING,
  OPEN_CREATE_RETURN_REASON_MODAL,
  OPEN_UPDATE_RETURN_REASON_MODAL,
  RETURN_REASON_LIST_ERROR,
  SET_ASSIGNABLE_RETURN_REASON_LIST_ASYNC,
  SET_RETURN_REASON_LIST,
  SET_RETURN_REASON_DETAILS,
  UPDATE_RETURN_REASON_ERROR,
  UPDATE_RETURN_REASON_PENDING,
  UPDATE_RETURN_REASON_SUCCESS,
  RETURN_REASON_LIST_ERROR_CLEAR
} from "./actionTypes";

const initialState = {
  //--------------------------------RETURN-REASON-LIST------------------------------------------------
  isReturnReasonPending: false,
  returnReasonList: [],
  totalRecords: null,
  returnReasonListError: null,
  //--------------------------------RETURN-REASON-CREATE----------------------------------------------
  isCreateReturnReasonModalOpen: false,
  isReturnReasonCreatePending: false,
  AddReturnReasonForm: {},
  returnReasonCreateError: null,
  //--------------------------------RETURN-REASON-EDIT------------------------------------------------
  isUpdateReturnReasonModalOpen: false,
  isReturnReasonUpdatePending: false,
  returnReasonDetails: {},
  updateReturnReasonError: null,

};

export default (localState = initialState, action) => {
  switch (action.type) {
    //--------------------------------RETURN-REASON-LIST------------------------------------------------
    case GET_RETURN_REASON_PENDING: {
      return {
        ...localState,
        isReturnReasonPending: true,
      };
    }

    case SET_RETURN_REASON_LIST: {
      const { returnReasonsOdata } = action.payload;
      return {
        ...localState,
        isReturnReasonPending: false,
        returnReasonListError: null,
        returnReasonList: returnReasonsOdata && returnReasonsOdata.value,
        totalRecords: returnReasonsOdata && returnReasonsOdata['@odata.count'],
      };
    }

    case RETURN_REASON_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        returnReasonListError: errorMessage,
        isReturnReasonPending: false,
        returnReasonList: [],
        totalRecords: 0
      };
    }
    case RETURN_REASON_LIST_ERROR_CLEAR: {
      return {
        ...localState,
        returnReasonListError: null,
        isReturnReasonPending: false,
      };
    }

    //--------------------------------RETURN-REASON-CREATE----------------------------------------------
    case OPEN_CREATE_RETURN_REASON_MODAL: {
      return {
        ...localState,
        isCreateReturnReasonModalOpen: true,
        returnReasonCreateError: null,
      };
    }

    case CLOSE_CREATE_RETURN_REASON_MODAL: {
      return {
        ...localState,
        isCreateReturnReasonModalOpen: false,
      };
    }
    case ADD_RETURN_REASON: {
      const { AddReturnReasonForm } = action.payload;
      return {
        ...localState,
        AddReturnReasonForm: AddReturnReasonForm
      };
    }
    case CREATE_RETURN_REASON_SUCCESS: {
      return {
        ...localState,
        isReturnReasonCreatePending: false,
      };
    }

    case CREATE_RETURN_REASON_PENDING: {
      return {
        ...localState,
        isReturnReasonCreatePending: true,
      };
    }

    case CREATE_RETURN_REASON_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        returnReasonCreateError: errorMessage,
        isReturnReasonCreatePending: false,
      };
    }

    case CLEAR_CREATE_RETURN_REASON_ERROR: {
      return {
        ...localState,
        returnReasonCreateError: null,
      };
    }

    case SET_ASSIGNABLE_RETURN_REASON_LIST_ASYNC: {
      const { returnReasonsListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        returnReasonsListAsync: returnReasonsListAsync,
        searchValueAsync
      }
    }
    //--------------------------------RETURN-REASON-EDIT------------------------------------------------
    case OPEN_UPDATE_RETURN_REASON_MODAL: {
      return {
        ...localState,
        isUpdateReturnReasonModalOpen: true,
        updateReturnReasonError: null,
      };
    }

    case CLOSE_UPDATE_RETURN_REASON_MODAL: {
      return {
        ...localState,
        isUpdateReturnReasonModalOpen: false,
      };
    }

    case SET_RETURN_REASON_DETAILS: {
      const { returnReasonDetails } = action.payload;
      return {
        ...localState,
        returnReasonDetails: returnReasonDetails
      }
    }

    case UPDATE_RETURN_REASON_PENDING: {
      return {
        ...localState,
        isReturnReasonUpdatePending: true,
      };
    }
    case UPDATE_RETURN_REASON_SUCCESS: {
      return {
        ...localState,
        isReturnReasonUpdatePending: false,
      };
    }

    case UPDATE_RETURN_REASON_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        updateReturnReasonError: errorMessage,
        isReturnReasonUpdatePending: false,
      };
    }

    case CLEAR_UPDATE_RETURN_REASON_ERROR: {
      return {
        ...localState,
        updateReturnReasonError: null,
      };
    }

    default: {
      return localState;
    }
  }
};
